import Api from "@/api/Api";
import errorHandler from "@/utils/plugins/ErrorHandler";
const RESOURCE_NAME = "/api/providers";

export default {
  async getProviders(params) {
    return await Api()
      .get(RESOURCE_NAME, { params })
      .catch((err) => errorHandler(err, null));
  },
  async getProvider(id) {
    return await Api()
      .get(RESOURCE_NAME + "/" + id)
      .catch((err) => errorHandler(err, null));
  },
  async postProvider(params) {
    return await Api()
      .post(RESOURCE_NAME, params)
      .catch((err) => errorHandler(err, null));
  },
  async updateProvider(id, params) {
    return await Api()
      .put(RESOURCE_NAME + "/" + id, params)
      .catch((err) => errorHandler(err, null));
  },
  async deleteProvider(id) {
    return await Api()
      .delete(RESOURCE_NAME + "/" + id)
      .catch((err) => errorHandler(err, null));
  },
};
